import {
  bool,
  func,
  string,
} from 'prop-types';
import {
  Box,
  Typography,
} from '@material-ui/core';

import Modal from '../Modal';

/**
 * Modal genérico de aviso no-cerrable con una sola acción.
 *
 * Todos los textos se inyectan por props, por lo que es reutilizable para
 * cualquier aviso. No es cerrable (no se pasa `events.onClose` y el backdrop
 * está deshabilitado en el Modal base); solo se sale con el botón de acción.
 *
 *
 * @param {boolean} open      Controla la visibilidad del modal.
 * @param {string}  title     Título del modal.
 * @param {string}  message   Mensaje/contenido del modal.
 * @param {string}  buttonLabel Texto del botón de acción.
 * @param {function} onAction Handler que se ejecuta al pulsar el botón.
 */
function AlertActionModal({ open, title, message, buttonLabel, onAction }) {
  return (
    <Modal
      open={open}
      maxWidth="xs"
      title={title}
      actions={[
        {
          color: 'primary',
          label: buttonLabel,
          fn: onAction,
        },
      ]}
    >
      <Box mb={1} mt={1}>
        <Typography
          align="center"
          children={message}
          color="textSecondary"
        />
      </Box>
    </Modal>
  );
}

AlertActionModal.defaultProps = {
  open: false,
  title: '',
  message: '',
  buttonLabel: '',
};

AlertActionModal.propTypes = {
  open: bool,
  title: string,
  message: string,
  buttonLabel: string,
  onAction: func,
};

export default AlertActionModal;
